import { useCallback, useEffect, useState } from "react";

import {
  getKoulutukset,
  getKurssit,
  getPatevyydet,
  getKielitaidot,
  getTyokokemukset,
  getReferenssit,
  getYritysReferenssit,
  getLaitteet,
  getItLaitteet,
} from "../../api/api.js";

export default function useUserProfile(userId) {
  const [loading, setLoading] = useState(false);

  const [koulutukset, setKoulutukset] = useState([]);
  const [kurssit, setKurssit] = useState([]);
  const [patevyydet, setPatevyydet] = useState([]);
  const [kielitaidot, setKielitaidot] = useState([]);
  const [tyokokemukset, setTyokokemukset] = useState([]);

  const [referenssit, setReferenssit] = useState([]);
  const [yritysReferenssit, setYritysReferenssit] = useState([]);

  const [laitteet, setLaitteet] = useState([]);
  const [itLaitteet, setItLaitteet] = useState([]);

  const [deletedKoulutusIds, setDeletedKoulutusIds] =
    useState([]);

  const [deletedKurssiIds, setDeletedKurssiIds] =
    useState([]);

  const [deletedPatevyysIds, setDeletedPatevyysIds] =
    useState([]);

  const [
    deletedKielitaitoIds,
    setDeletedKielitaitoIds,
  ] = useState([]);

  const [
    deletedTyokokemusIds,
    setDeletedTyokokemusIds,
  ] = useState([]);

  const [
    deletedReferenssit,
    setDeletedReferenssit,
  ] = useState([]);

  const [
    deletedYritysReferenssit,
    setDeletedYritysReferenssit,
  ] = useState([]);

  const resetDeleted = useCallback(() => {
    setDeletedKoulutusIds([]);
    setDeletedKurssiIds([]);
    setDeletedPatevyysIds([]);
    setDeletedKielitaitoIds([]);
    setDeletedTyokokemusIds([]);
    setDeletedReferenssit([]);
    setDeletedYritysReferenssit([]);
  }, []);

  const loadProfile = useCallback(async () => {
    if (!userId) return;

    try {
      setLoading(true);

      const [
        koulutusData,
        kurssiData,
        patevyysData,
        kielitaitoData,
        tyokokemusData,
        referenssiData,
        yritysReferenssiData,
        laiteData,
        itLaiteData,
      ] = await Promise.all([
        getKoulutukset(userId),
        getKurssit
          ? getKurssit(userId)
          : Promise.resolve([]),

        getPatevyydet(userId),
        getKielitaidot(userId),
        getTyokokemukset(userId),

        getReferenssit(userId),
        getYritysReferenssit(),

        getLaitteet(userId),
        getItLaitteet(userId),
      ]);

      setKoulutukset(
        Array.isArray(koulutusData)
          ? koulutusData
          : []
      );

      setKurssit(
        Array.isArray(kurssiData)
          ? kurssiData
          : []
      );

      setPatevyydet(
        Array.isArray(patevyysData)
          ? patevyysData
          : []
      );

      setKielitaidot(
        Array.isArray(kielitaitoData)
          ? kielitaitoData
          : []
      );

      setTyokokemukset(
        Array.isArray(tyokokemusData)
          ? tyokokemusData
          : []
      );

      setReferenssit(
        Array.isArray(referenssiData)
          ? referenssiData
          : []
      );

      setYritysReferenssit(
        Array.isArray(yritysReferenssiData)
          ? yritysReferenssiData
          : []
      );

      setLaitteet(
        Array.isArray(laiteData)
          ? laiteData
          : []
      );

      setItLaitteet(
        Array.isArray(itLaiteData)
          ? itLaiteData
          : []
      );

      resetDeleted();
    } finally {
      setLoading(false);
    }
  }, [userId, resetDeleted]);

  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  return {
    loading,
    reload: loadProfile,

    koulutukset,
    setKoulutukset,

    kurssit,
    setKurssit,

    patevyydet,
    setPatevyydet,

    kielitaidot,
    setKielitaidot,

    tyokokemukset,
    setTyokokemukset,

    referenssit,
    setReferenssit,

    yritysReferenssit,
    setYritysReferenssit,

    laitteet,
    setLaitteet,

    itLaitteet,
    setItLaitteet,

    deletedKoulutusIds,
    setDeletedKoulutusIds,

    deletedKurssiIds,
    setDeletedKurssiIds,

    deletedPatevyysIds,
    setDeletedPatevyysIds,

    deletedKielitaitoIds,
    setDeletedKielitaitoIds,

    deletedTyokokemusIds,
    setDeletedTyokokemusIds,

    deletedReferenssit,
    setDeletedReferenssit,

    deletedYritysReferenssit,
    setDeletedYritysReferenssit,

    resetDeleted,
  };
}